import { Component, OnInit, ChangeDetectionStrategy, Input, OnChanges, ChangeDetectorRef, SimpleChanges } from '@angular/core';

import * as moment from 'moment';
import { AccountService } from '../../../services/account.service';

@Component({
  selector: 'app-card-balance',
  templateUrl: './card-balance.component.html',
  styleUrls: ['./card-balance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardBalanceComponent implements OnInit, OnChanges {
  @Input() division;
  @Input() accountFinBalances;
  @Input() calsBalances;
  @Input() calsTotal;
  @Input() caliBalances;
  @Input() caliTotal;
  // Margin trading total already loaded by the dashboard; when set, the card doesn't fetch its own
  @Input() ledgerTotal: number | null = null;
  disableBalanceView = false;
  currentUser;
  totalInProgress;
  toDate = new Date();
  marginTradeTotal = 0;
  constructor(private cdRef: ChangeDetectorRef, private accountService: AccountService) { }

  async ngOnInit() {
    this.currentUser = await this.accountService.currentUserAsync();
    this.cdRef.detectChanges();
  }

  async ngOnChanges(changes: SimpleChanges) {
    // if (changes['accountFinBalances'] && this.accountFinBalances) {
    //   console.log(this.accountFinBalances);
    // }
    if (this.division === 'LEDGER' && (changes['division'] || changes['ledgerTotal'])) {
      if (this.ledgerTotal !== null && this.ledgerTotal !== undefined) {
        this.marginTradeTotal = this.ledgerTotal;
        this.cdRef.detectChanges();
      } else if (!localStorage['marginTradeTotal']) {
        await this.getLedgerTotal();
      } else {
        this.marginTradeTotal = localStorage['marginTradeTotal'];
        this.cdRef.detectChanges();
      }
    }
  }
  getLedgerTotal = async () => {
    let marginTradeDetails = [];
    let toDate = moment(this.toDate).format('YYYY-MM-DD');
    if (!this.currentUser) this.currentUser = await this.accountService.currentUserAsync();
    for (const margins of this.currentUser?.marginTradeDetails) {
      try {
        this.totalInProgress = true;
        this.cdRef.detectChanges();

        let data = await this.accountService.getMarginTradePortfolio(toDate, margins.customerCode);
        this.totalInProgress = false;
        const total = Number(String(data?.marketValueTotal ?? '').replace(/,/g, '')) || 0;
        marginTradeDetails.push({ code: margins.customerCode, total });
        this.marginTradeTotal += total;
        localStorage.setItem('marginTradeTotal', this.marginTradeTotal.toString());
        localStorage.setItem('marginTradeDetails', JSON.stringify(marginTradeDetails));
        this.cdRef.detectChanges();
      } catch (e) {
        this.totalInProgress = false;
      }
    }
  };
}
